import { sendFetch, sendInfoManagerFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';
import { getCompany } from '../_utils/storage_handler';
import { buildTimeStampString } from '../_utils/date_format.utils';

const BASE_PATH_INFO = '/payments';
const BASE_PATH = '/payments';

export const uploadPaymentsData = async (bytes, extension, type, date_created) => {
    let body = {
        bytes,
        extension,
        type,
        company: getCompany(),
        date_created: buildTimeStampString(date_created ? date_created : new Date())
    }
    return await sendInfoManagerFetch(`${BASE_PATH_INFO}`, POST_OPTIONS, body);
}

export const findAllPayments = async () => {
    return await sendFetch(`${BASE_PATH}/all/${getCompany()}`, GET_OPTIONS);
}

export const findAllDateGroupPayments = async () => {
    return await sendFetch(`${BASE_PATH}/all-date-group/company/${getCompany()}`, GET_OPTIONS);
}

export const findAllDateGroupClientPayments = async (client) => {
    return await sendFetch(`${BASE_PATH}/all-date-group/client/company/${client}/${getCompany()}`, GET_OPTIONS);
}

export const findClientPayments = async (client_cod) => {
    return await sendSellerFetch(`${BASE_PATH}/all/client/${getCompany()}/${client_cod}`, GET_OPTIONS);
}